import axios from "axios";

const api = axios.create({
  withCredentials: true,
  headers: {
    "Content-Type": "application/json",
  },
});

// Token storage
let token = localStorage.getItem("token") || null;

export function setToken(newToken) {
  token = newToken;
  localStorage.setItem("token", newToken);
}

export function clearToken() {
  token = null;
  localStorage.removeItem("token");
}

export function getToken() {
  return token;
}

// Map a bare "/api/..." path to the audience-scoped namespace based on the
// current area: contestant pages talk to /contestant/api, everything else (liveness/
// admin, /login, SSO) to /liveness/api. There is no single /api root.
function apiAreaPrefix() {
  return window.location.pathname.startsWith("/contestant") ? "/contestant" : "/liveness";
}

// Request interceptor — attach Bearer token and route to the area's API namespace
api.interceptors.request.use((config) => {
  if (token) {
    config.headers["Authorization"] = `Bearer ${token}`;
  }
  if (config.url && config.url.startsWith("/api/")) {
    config.url = apiAreaPrefix() + config.url;
  }
  // Let the browser set multipart/form-data (with boundary) for file uploads.
  if (typeof FormData !== "undefined" && config.data instanceof FormData) {
    delete config.headers["Content-Type"];
  }
  return config;
});

// Response interceptor — on 401, clear token and redirect to login
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (
      error.response?.status === 401 &&
      !error.config.url?.includes("/api/auth/")
    ) {
      clearToken();
      window.location.href = window.location.pathname.startsWith("/contestant")
        ? "/contestant"
        : "/liveness/login";
    }
    return Promise.reject(error);
  }
);

export default api;
